import PropTypes from 'prop-types';
import React, { useState } from 'react';
import SimpleAccordion from 'ripple/Components/Accordion';
import useIsMobile from 'lib/useIsMobile';
import ProductGridView from 'ripple/Events/Containers/ListViews/Products';
import HTMLFragment from 'components/HTMLFragment';

const EventMeta = ({ viewer, onAccordionChange, event }) => {
  const mobile = useIsMobile();
  const [expanded, setExpanded] = useState('products');

  const handleChange = panel => (events, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    if (onAccordionChange) {
      onAccordionChange(`Expand - ${events.target.innerText || panel}`);
    }
  };

  const styles = {
    accordionText: {
      fontSize: '1rem',
      // margin: '3% 12% 3% 7%',
    },
  };

  return event?.id ? (
    <div style={{ width: '100%', margin: mobile ? '10px 0' : 0 }}>
      <SimpleAccordion
        comps={(
          <HTMLFragment style={styles.accordionText}>
            {event?.sponsorDescription}
          </HTMLFragment>
        )}
        title={`About ${event?.community?.name}`}
        expanded={expanded === 'about'}
        onChange={handleChange('about')}
      />
      <SimpleAccordion
        comps={<ProductGridView viewer={viewer} eventId={event?.id} />}
        title={`${event?.community?.name} Products`}
        expanded={expanded === 'products'}
        onChange={handleChange('products')}
      />
      {(event?.adultOnly || event?.disclaimer) && (
        <SimpleAccordion
          comps={(
            <p style={styles.accordionText}>
              <HTMLFragment>
                {event?.disclaimer
                  || `You must be 21 or older to apply, host and attend this party. State
              laws do not allow us to provide alcoholic beverages to our hosts.
              Guests of the party who aren’t registered with House Party must sign
              a waiver (available in the Favors tab) and return it to us by either
              faxing it to 1-914-801-5675 or emailing it to
              waivers@ripplestreet.com.`}
              </HTMLFragment>
            </p>
          )}
          title='The Fine Print'
          expanded={expanded === 'fineprint'}
          onChange={handleChange('fineprint')}
        />
      )}
      {/* <SimpleAccordion
        comps={(
          <p style={styles.accordionText}>
            Sign up for the SMS notifications. Learn more here.
          </p>
        )}
        title='Sign Up For SMS Notifications'
        expanded={expanded === 'sms'}
        onChange={handleChange('sms')}
      /> */}
    </div>
  ) : (
    <></>
  );
};

EventMeta.propTypes = {
  viewer: PropTypes.object.isRequired,
  onAccordionChange: PropTypes.func,
  event: PropTypes.object.isRequired,
};

export default EventMeta;
